import { Button, Input, Modal, Spin, Table, Typography, message } from "antd";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { ConfigurationAPI } from "../../API/ConfigurationAPI";
import { RankingAPI } from "../../API/RankingAPI";
import { UploadDataAPI } from "../../API/UploadDataAPI";
import HeaderTab from "../../Components/headerTab/HeaderTab";
import { AddEmployee } from "../../Components/modals/AddEmploye";
import { EMPLOYEE_COLUMNS_HEAD, INITIAL_OBJECT } from "./ConfigurationUtils";
import TableEmptyContent from "../../Components/TableEmptyContent/TableEmptyContent";
import { useFlightModel } from "../../contexts/FlightModelContext";
const { Text } = Typography;
const { info } = Modal;

export default function Configuration() {
  const INPUT_REGEX = /^(?!0+(\.0*)?$)(\d+(\.\d*)?|(\.\d+))$/;
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const [spinning, setSpinning] = useState(false);
  const [inputElements, setInputElements] = useState(INITIAL_OBJECT);
  const [fileData, setFileData] = useState({});
  const [addEmployeeModal, setAddEmployeeModal] = useState(false);
  const [emplyeeList, setEmployeeList] = useState([]);
  const { selectedFlightModel, refreshFlightModels } = useFlightModel();

  function inputOnChange(value, key) {
    let error = "";
    if (!value.trim()) {
      error = "Field is required";
    } else if (!INPUT_REGEX.test(String(value.trim()).trim())) {
      error = "Invalid Input Data";
    } else if (value.trim() > 10000) {
      error = "MAX Value 10000!";
    }

    setInputElements((prev) => ({
      ...prev,
      [key]: value.trim(),
      errorFieds: {
        ...prev.errorFieds,
        [key]: error,
      },
    }));
  }

  async function loadConfigData() {
      let flightModelToUse = selectedFlightModel;

    // fallback from context
    if (!flightModelToUse) {
      const refreshed = await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }

    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }
    const queryParams = {
      params: {
        flight_model: flightModelToUse
        // localStorage.getItem("flight_model"),
      },
    };
    setSpinning(true);
    await ConfigurationAPI.getCofigData(queryParams)
      .then((res) => {
        if (res.data.status === true) {
          setInputElements({
            fleetCount: res.data?.data?.avg_fleet_size,
            flightHours: res.data?.data?.per_dy_fl_hr,
            flightCycle: res.data?.data?.per_dy_fl_cy,
            laborRate: res.data?.data?.labour_rate,
            aircraftLifTime: res.data?.data?.avg_life_cy,
            errorFieds: {
              fleetCount: "",
              flightHours: "",
              flightCycle: "",
              laborRate: "",
              aircraftLifTime: "",
            },
          });
          setFileData({ ...res.data?.data?.last_file });
          const arr = res.data?.employee_details.map((ele, index) => ({
            ...ele,
            serial_no: index + 1,
          }));
          setEmployeeList(arr);
        } else {
          messageToast("error", res.data?.message);
        }
      })
      .catch(() => messageToast("error", "Internal Server Error"))
      .finally(() => setSpinning(false));
  }

  async function saveConfigData() {
    if (formValidation()) {
      setSpinning(true);
         let flightModelToUse = selectedFlightModel;

    // fallback from context
    if (!flightModelToUse) {
      const refreshed = await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }

    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }
      const bodyData = {
        flight_model:flightModelToUse,
        //  localStorage.getItem("flight_model"),
        per_dy_fl_hr: inputElements.flightHours,
        per_dy_fl_cy: inputElements.flightCycle,
        avg_life_cy: inputElements.aircraftLifTime,
        labour_rate: inputElements.laborRate,
        avg_fleet_size: inputElements.fleetCount,
      };
      await ConfigurationAPI.postCofigData(bodyData)
        .then((res) => {
          if (res.data.status === true) {
            messageToast("success", res.data?.message);
            fileData?.is_ranked === true ? newRanking() : reRnakFunc();
          } else {
            messageToast("error", res.data?.message);
            setSpinning(false);
          }
        })
        .catch(() => {
          messageToast("error", "Internal Server Error");
          setSpinning(false);
        });
    }
  }

  function formValidation() {
    let isValid = false;
    let obj = { ...inputElements };

    obj.errorFieds = {
      ...inputElements.errorFieds,
      fleetCount: !inputElements.fleetCount
        ? "Field is required"
        : !INPUT_REGEX.test(String(inputElements.fleetCount).trim())
          ? "invalid Input Data"
          : inputElements.fleetCount > 10000
            ? "MAX Value 10000!"
            : "",
      aircraftLifTime: !inputElements.aircraftLifTime
        ? "Field is required"
        : !INPUT_REGEX.test(String(inputElements.aircraftLifTime).trim())
          ? "invalid Input Data"
          : inputElements.aircraftLifTime > 10000
            ? "MAX Value 10000!"
            : "",
      flightCycle: !inputElements.flightCycle
        ? "Field is required"
        : !INPUT_REGEX.test(String(inputElements.flightCycle).trim())
          ? "invalid Input Data"
          : inputElements.flightCycle > 10000
            ? "MAX Value 10000!"
            : "",
      flightHours: !inputElements.flightHours
        ? "Field is required"
        : !INPUT_REGEX.test(String(inputElements.flightHours).trim())
          ? "invalid Input Data"
          : inputElements.flightHours > 10000
            ? "MAX Value 10000!"
            : "",
      laborRate: !inputElements.laborRate
        ? "Field is required"
        : !INPUT_REGEX.test(String(inputElements.laborRate).trim())
          ? "invalid Input Data"
          : inputElements.laborRate > 10000
            ? "MAX Value 10000!"
            : "",
    };

    setInputElements(obj);

    if (
      obj.fleetCount &&
      !obj.errorFieds.fleetCount &&
      obj.aircraftLifTime &&
      !obj.errorFieds.aircraftLifTime &&
      obj.flightCycle &&
      !obj.errorFieds.flightCycle &&
      obj.flightHours &&
      !obj.errorFieds.flightHours &&
      obj.laborRate &&
      !obj.errorFieds.laborRate
    ) {
      isValid = true;
    }

    return isValid;
  }

  async function newRanking() {
       let flightModelToUse = selectedFlightModel;

    // fallback from context
    if (!flightModelToUse) {
      const refreshed = await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }

    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }
    const queryParams = {
      params: {
        flight_model: flightModelToUse
        // localStorage.getItem("flight_model"),
      },
    };
    setSpinning(true);
    await RankingAPI.resetRank(queryParams)
      .then((res) => {
        res.data.status === true
          ? infoModal()
          : messageToast("error", res.data?.message);
      })
      .catch(() => messageToast("error", "Internal Server Error"))
      .finally(() => setSpinning(false));
  }

  async function reRnakFunc() {
       let flightModelToUse = selectedFlightModel;

    // fallback from context
    if (!flightModelToUse) {
      const refreshed = await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }

    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }
    const queryParams = {
      params: {
        flight_model: flightModelToUse
        // localStorage.getItem("flight_model"),
      },
    };
    setSpinning(true);
    await UploadDataAPI.reRank(queryParams)
      .then((res) => {
        res.data.status === true
          ? infoModal()
          : messageToast("error", res.data?.message);
      })
      .catch((err) => messageToast("error", "Internal Server Error"))
      .finally(() => setSpinning(false));
  }

  function infoModal() {
    let strDate = "";
    if (fileData?.uploaded_on) {
      strDate = new Date(fileData?.uploaded_on);
    }
    info({
      title: "Info",
      content: (
        <Text style={{ fontSize: "16px" }}>
          Ranking applied to file:{" "}
          <Text mark strong italic>
            {fileData?.file}
          </Text>{" "}
          uploaded on{" "}
          <Text mark strong italic>
            {String(strDate).slice(4, 15)}
          </Text>
        </Text>
      ),
      okText: "Close",
      onOk() {
        navigate("/ranking");
      },
      onCancel() {
        navigate("/ranking");
      },
    });
  }

  useEffect(() => {
    loadConfigData();
  }, []);

  const messageToast = (type, message) => {
    messageApi.open({
      type: type,
      content: message,
      duration: 6,
    });
  };

  return (
    <div className="container_div">
      <Helmet>
        <title>SpecOptimzer | Settings</title>
      </Helmet>
      <Spin spinning={spinning}>
        <HeaderTab currrentTab="settings" />

        <div className="config_split_div">
          {/* Cofiguration Iputs */}
          <div className="box_wraper_div">
            <div className="table_head_wraper">
              <Text className="table_head">Cost Calculation Settings</Text>
            </div>

            <div className="config_wraper">
              <div style={{}}>
                <label style={{ color: "#666666" }}>AC. On Spec</label>
                <Input
                  status={!inputElements.errorFieds.fleetCount ? "" : "error"}
                  min={1}
                  value={inputElements.fleetCount}
                  onChange={(e) => inputOnChange(e.target.value, "fleetCount")}
                  style={{ display: "block", width: "100%", marginTop: "10px" }}
                  size="large"
                />
                <Text type="danger" italic>
                  {inputElements.errorFieds.fleetCount}
                </Text>
              </div>
              <div style={{}}>
                <label style={{ color: "#666666" }}>
                  Avg. Flight Hours Per Day
                </label>
                <Input
                  status={!inputElements.errorFieds.flightHours ? "" : "error"}
                  min={1}
                  value={inputElements.flightHours}
                  onChange={(e) => inputOnChange(e.target.value, "flightHours")}
                  style={{ display: "block", width: "100%", marginTop: "10px" }}
                  size="large"
                />
                <Text type="danger" italic>
                  {inputElements.errorFieds.flightHours}
                </Text>
              </div>
              <div style={{}}>
                <label style={{ color: "#666666" }}>
                  Avg. Flight Cycles Per Day
                </label>
                <Input
                  status={!inputElements.errorFieds.flightCycle ? "" : "error"}
                  min={1}
                  value={inputElements.flightCycle}
                  onChange={(e) => inputOnChange(e.target.value, "flightCycle")}
                  style={{ display: "block", width: "100%", marginTop: "10px" }}
                  size="large"
                />
                <Text type="danger" italic>
                  {inputElements.errorFieds.flightCycle}
                </Text>
              </div>
              <div style={{}}>
                <label style={{ color: "#666666" }}>
                  Approx. Labor Rate ($)
                </label>
                <Input
                  status={!inputElements.errorFieds.laborRate ? "" : "error"}
                  min={1}
                  value={inputElements.laborRate}
                  onChange={(e) => inputOnChange(e.target.value, "laborRate")}
                  style={{ display: "block", width: "100%", marginTop: "10px" }}
                  size="large"
                />
                <Text type="danger" italic>
                  {inputElements.errorFieds.laborRate}
                </Text>
              </div>
              <div style={{}}>
                <label style={{ color: "#666666" }}>Avg. AC Age</label>
                <Input
                  status={
                    !inputElements.errorFieds.aircraftLifTime ? "" : "error"
                  }
                  min={1}
                  value={inputElements.aircraftLifTime}
                  onChange={(e) =>
                    inputOnChange(e.target.value, "aircraftLifTime")
                  }
                  style={{ display: "block", width: "100%", marginTop: "10px" }}
                  size="large"
                />
                <Text type="danger" italic>
                  {inputElements.errorFieds.aircraftLifTime}
                </Text>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              <Button onClick={loadConfigData} style={{ marginRight: "15px" }}>
                Cancel
              </Button>
              <Button type="primary" onClick={saveConfigData}>
                Save & Rank
              </Button>
            </div>
          </div>

          {/* Add Team Members */}
          <div className="box_wraper_div">
            <div className="table_head_wraper">
              <Text className="table_head">List of Team Members</Text>
            </div>

            <div style={{}}>
              <Table
                rowKey="key"
                columns={EMPLOYEE_COLUMNS_HEAD()}
                dataSource={emplyeeList}
                pagination={{
                  pageSize: 5,
                  responsive: true,
                  hideOnSinglePage: true,
                }}
                style={{ marginTop: "20px" }}
                className="antdTable"
                locale={{
                  emptyText: <TableEmptyContent />,
                }}
              />
            </div>
          </div>
        </div>

        <AddEmployee
          open={addEmployeeModal}
          setOpen={setAddEmployeeModal}
          messageToast={messageToast}
          loadConfigData={loadConfigData}
        />
        {contextHolder}
      </Spin>
    </div>
  );
}
